import { useContext, useEffect, useState } from 'react';
import { useTranslation } from "react-i18next";
import { useForm } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { MdOutlineVisibility, MdOutlineVisibilityOff } from 'react-icons/md';


//components
import { toast } from "react-toastify";
import { Button, Container, Row, Col, Form, Stack, Spinner } from 'react-bootstrap';
import { Illustration } from "../styled"
import logo from "../../../../assets/img/logo.svg";
import logoWhite from "../../../../assets/img/logo-white.svg";
import loginIllustration from "../../../../assets/img/login-illustration.png";

// services
import { auth, me } from '../../../services/login/login.service';
import UsuarioContext, { DEFAULT_VALUE } from "../../../../context/userContext/context";
import SystemContext from "../../../../context/systemContext/context";
import Error from "../../../components/Error";
import { colors } from '../../../../theme/theme';
import { createFavoriteBulk } from '../../../services/create-account/create-account.service';
import { bulkStorageFavoriteMaterials } from '../../../utils/storageFavoriteMaterials';
import { useHistory } from 'react-router-dom';

const validationSchema = Yup.object({
  email: Yup.string().email('E-mail inválido').required("Este campo é obrigatório"),
  password: Yup.string().required("Este campo é obrigatório"),
}).required();

const Login = (): JSX.Element => {
  const history = useHistory();
  const { user, update } = useContext(UsuarioContext)
  const { systemConfig } = useContext(SystemContext)
  const { t: translation } = useTranslation();
  const { register, handleSubmit, formState: { errors } } = useForm({ resolver: yupResolver(validationSchema) });


  const [loading, setLoading] = useState<boolean>(false);
  const [showPassword, setShowPassword] = useState<boolean>(false);

  useEffect(() => {
    update(DEFAULT_VALUE.user);
  }, []);

  const onSubmit = (userForm: any) => {
    setLoading(true);
    auth(userForm.email, userForm.password).then((response) => {
      update({ ...user, token: response.access_token });
      me().then((res) => {
        update({
          ...user,
          token: response.access_token,
          id: res.id,
          name: res.name,
          email: res.email,
          company: res.company,
          job: res.job,
          phone: res.phone,
          picture: res.picture,
          username: res.username,
          is_active: res.is_active,
          is_staff: res.is_staff,
          is_superuser: res.is_superuser,
          is_whatsapp: res.is_whatsapp,
          is_signature: res.is_signature,
          profile_status: res.profile_status
        });

        const favorites = bulkStorageFavoriteMaterials()

        createFavoriteBulk(favorites).then(() => {
          window.location.href = "/home";
        })

      })
    })
      .catch((err) => {
        setLoading(false);
        toast.error('Usuário ou senha inválidos! Tente novamente', { autoClose: 7000 })
      })
  }

  return (
    <Container fluid>
      <Row className="row-card-login">
        <Col xs={'auto'} lg={6} xl={7} xxl={8} className="p-0 vh-100 d-flex justify-content-center align-items-center">
          <Row className="row-illustration-login">
            <Col xs={12} className="vh-50 illustration">
              <Illustration image={loginIllustration}/>
            </Col>
            <Col xs={12} className="text-center text-welcome">
              <h3 className="text-white"><b>{translation('login.welcome')}</b></h3>
              <h5 className="text-white">{translation('login.description')}</h5>
            </Col>
          </Row>
        </Col>
        <Col className="d-flex align-items-center card-login">
          <div className="wrapper-login">
            <Form className="w-100 form-auth" onSubmit={handleSubmit(onSubmit)}>
              <Col className="text-center mb-2rem">
                {
                  systemConfig.theme === "light" ? (<img src={logo} alt="Logo" height={65} />) : (<img src={logoWhite} alt="Logo" height={65} />)
                }
              </Col>
              <Form.Group className="mb-2rem">
                <Form.Label className="text-black"><b>{translation('login.loginText')}</b></Form.Label>
                <Form.Control
                  data-testid="user-field"
                  type="text"
                  placeholder={translation('login.loginPlaceholder')}
                  aria-label={translation('login.loginPlaceholder')}
                  {...register("email", { required: true })}
                />
                {errors.email ? (<div className="w-100"> <Error>{errors.email?.message}</Error> </div>) : ""}
              </Form.Group>

              <Form.Group className="">
                <Form.Label className="text-black"><b>{translation('login.password')}</b></Form.Label>
                <div className="d-flex position-relative">
                  <Form.Control
                    data-testid="password-field"
                    type={showPassword ? "text" : "password"}
                    placeholder={translation('login.password')}
                    aria-label={translation('login.password')}
                    {...register("password", { required: true })}
                  />
                  <span className="eye-password-icon">
                    {
                      showPassword ? (
                        <MdOutlineVisibility style={{ width: "22px", height: "22px", color: colors.greyscale.black }} onClick={() => setShowPassword(false)} />
                      ) : (
                        <MdOutlineVisibilityOff style={{ width: "22px", height: "22px", color: colors.greyscale.black }} onClick={() => setShowPassword(true)} />
                      )
                    }
                  </span>
                </div>

                {errors.password ? (<div className="w-100"> <Error>{errors.password?.message}</Error> </div>) : ""}
              </Form.Group>
              <Row>
                <Col xs={12} sm={12} md={12} lg={12} className="text-end font-14 mt-2 mb-2rem">
                  <a href="#" className="text-blueberry" onClick={() => history.push('/recovery-password')}>
                    <b>{translation('login.forgotPassword')}</b>
                  </a>
                </Col>
              </Row>

              {
                loading ? (
                  <div className="loading-container">
                    <Spinner animation="border" variant="primary" />
                  </div>
                ) : (
                  <Stack gap={5} className="col-12 mx-auto text-center">
                    <Button variant="primary" type="submit" className="btn-rounded"><b>{translation('login.login').toUpperCase()}</b></Button>
                    <Form.Text id="passwordHelpBlock" style={{ fontSize: '16px' }} className="text-black">
                      {translation('login.notHaveAccount')} &nbsp;
                      <a href="#" className="text-blueberry" onClick={() => history.push('/create-account')}>
                        <b>{translation('login.createAccount')}</b>
                      </a>
                    </Form.Text>
                  </Stack>
                )
              }
            </Form>
          </div>
        </Col>
      </Row>
    </Container>
  )
}

export default Login;